import React, { useContext } from 'react'
import { extractData, notify, prefix } from '../../../../utils/index_tagging_tool'
import { api } from '../../../../utils/index'

export function ThanosEnableOperation({ context }) {
  const { operationsPossible, checkedRules, dimension, setLoading } =
    useContext(context)

  const enableThanosRule = async (rule) => {
    return api.post(`${prefix}thanos-rules/`, { rule: rule.id, custom: dimension })
  }

  const thanosRules = async (e) => {
    e.preventDefault()
    setLoading(true)
    const ruleList = JSON.parse(JSON.stringify(checkedRules))
    await Promise.all(
      ruleList.map(async (rule) => {
        // Scorro i selezionati e cancello tutto
        if (rule.id !== -1) {
          try {
            const response = await enableThanosRule(rule)
            extractData(response)
          } catch (e) {
            notify(e.message, 'error')
          }
        }
      })
    )
    window.location.reload()
  }

  return (
    <>
      {operationsPossible.includes('Abilita Thanos') && (
        <div className={'operationsDiv'} onClick={thanosRules}>
          Abilita Thanos
        </div>
      )}
    </>
  )
}
